import type { JSX } from "react";
export function CancelledCallControls(): JSX.Element {
    // TODO: To be implemented, how do we want to handle call status
    return <div />;
}
